import { AnimatePresence } from "framer-motion";
import { Modal } from "../modal";
import type { FC } from "react";

type LocationProps = {
  isOpen?: boolean;
  onClose?: () => void;
};

export const Location: FC<LocationProps> = ({ isOpen, onClose }) => {
  return (
    <AnimatePresence>
      {isOpen && <Modal isOpen={isOpen} onClose={onClose!} />}
    </AnimatePresence>
  );
};
